import React, { useState } from 'react'
import PropTypes from 'prop-types'

const ThresholdContext = React.createContext({})
ThresholdContext.displayName = 'ThresholdContext'
export default ThresholdContext

const ThresholdStore = ({ children }) => {
  const [get, set] = useState(3)
  return (
    <ThresholdContext.Provider value={{ get, set }}>
      {children}
    </ThresholdContext.Provider>
  )
}
ThresholdStore.propTypes = { children: PropTypes.node.isRequired }
export { ThresholdStore }
